import React, { useMemo } from 'react';
import ReactImageGallery from 'react-image-gallery';
import { IS_NEXT_EXPORT } from '../../utils/export';
import 'react-image-gallery/styles/css/image-gallery.css';
import { Container, Wrapper, StaticImage } from './ImageGallery.styled';
import RenderItem from './RenderItem';

const ImageGallery = ({ images, isModifiedImageOnPrint }) => {
  const highestImage = useMemo(
    () =>
      images.length > 1
        ? images.reduce((prev, curr) =>
            prev.originalHeight > curr.originalHeight ? prev : curr,
          ).originalHeight
        : null,
    [images],
  );

  return IS_NEXT_EXPORT ? (
    <Container>
      <Wrapper>
        {images.map(({ original }) => (
          <StaticImage key={original} src={original} width='530' priority />
        ))}
      </Wrapper>
    </Container>
  ) : (
    <Container>
      <ReactImageGallery
        items={images}
        thumbnailPosition='top'
        showThumbnails={images.length > 1}
        showPlayButton={false}
        showNav={false}
        renderItem={(item) => (
          <RenderItem
            {...item}
            highestImage={highestImage}
            isModifiedImageOnPrint={isModifiedImageOnPrint}
          />
        )}
      />
    </Container>
  );
};

export default ImageGallery;
